import { render } from "./productSeleectTemplateUrl.vue?vue&type=template&id=007ffa74&ts=true"
import script from "./productSeleectTemplateUrl.vue?vue&type=script&lang=ts"
export * from "./productSeleectTemplateUrl.vue?vue&type=script&lang=ts"

import "./productSeleectTemplateUrl.vue?vue&type=style&index=0&id=007ffa74&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__